import BaseRepository from './base.repository';

class FirebasePushRepository extends BaseRepository {
  constructor() {
    super('/firebase/push');
  }

  subscribe(payload, config) {
    return this.client.post('/subscribe', payload, {
      ...config,
      silent: true,
      noLoading: true,
      sessionIndependent: true,
    });
  }

  unsubscribe(payload, config) {
    return this.client.post('/unsubscribe', payload, {
      ...config,
      silent: true,
      noLoading: true,
      sessionIndependent: true,
    });
  }
}

export default new FirebasePushRepository();
